<div class="m-multi-row" [formGroup]="rowData">
	<div class="form-row row">

		<button type="button" *ngIf="displayX" class="close" aria-label="Close" (click)="removed.emit(index)">
			<span aria-hidden="true">&times;</span>
		</button>

		<!-- type -->
		<div class="col-12 offset-md-2 col-md-4">
			<div class="text-right m-title">
				{{'CYCLE_MIXTURE_ROW.TITLE_TYPE' | translate}} {{index + 1}}
			</div>
			<select formControlName="type" class="form-control m-form-control"
				[attr.aria-label]="'0'">
				<option [value]="defaultValue">{{"CYCLE_DETAILS.Q9-4.PH1"|translate}}</option>
				<option *ngFor="let status of productsList" [value]="status">{{status}}</option>
			</select>
			<div class="m-error" *ngIf="rowData.get('type').hasError('required') && displayErrors">
				{{ 'COMMON.FIELD_REQUIRED' | translate }}
			</div>
		</div>

		<!-- requesting amount -->
		<div class="col-12 col-md-6">
			<div class="row" *ngIf="1 || rowData.get('type').value === 'אחר'">
				<div class="col-12 col-md-6">
					<div class="text-right m-title">
						{{ 'CYCLE_MIXTURE_ROW.TITLE_AMOUNT' | translate }} {{index + 1}}
					</div>

					<!-- formControlName="amount"  [attr.id]="'amount'+index"-->
					<input currencyMask type="tel" formControlName="amount"
						class="form-control m-sm-form-control" [attr.aria-label]="'0'" />

						<div class="m-error" *ngIf="rowData.get('amount').hasError('required') && displayErrors">
							{{ 'COMMON.FIELD_REQUIRED' | translate }}
						</div>
				</div>
			</div>
		</div>
	</div>
</div>


// WEBPACK FOOTER //
// ./src/app/cycle-mixture-row/cycle-mixture-row.component.html